import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const Flyht = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#0d6381',
            100: '#107397',
            200: '#1284ac',
            300: '#1494c2',
            400: '#17a5d8',
            500: '#2eaedb',
            600: '#45b7df',
            700: '#5cc0e3',
            800: '#73c9e7',
            900: '#8bd2eb',
            950: '#a2dbef'
        },
        colorScheme: {
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '#e9eaeb',
                    100: '#d4d5d7',
                    200: '#bec0c3',
                    300: '#bec0c3',
                    400: '#a9abaf',
                    500: '#7e8288',
                    600: '#696d74',
                    700: '#535860',
                    750: '#313843',
                    800: '#3e434c',
                    850: '#37404C',
                    900: '#292f39',
                    950: '#242a33',
                },
                secondaryNav: '#23333E',
                flyht: {
                    red: '#fd8f8b',
                    amber: '#faeca0',
                    green: '#7fc97d',
                }
            }
        },
        body: {
            margin: 0
        },
        border: {
            radius: {
                xs: '6px',
                sm: '6px',
                md: '6px', // Buttons and DragAndDrop
                lg: '6px',
                xl: '6px' // Cards
            }
        },
    },
    components: {
        select: {
            disabled: {
                background: "transparent"
            }
        },
        menubar: {
            borderRadius: '0px',
            borderColor: 'none',
            padding: '0.5rem 2rem',
            item: {
                focus: {
                    background: "transparent",
                    textDecoration: "underline"
                }
            }
        },
        progressspinner: {
            colorScheme: {
                dark: {
                    color: {
                        one: "{primary.500}",
                        two: "{primary.500}",
                        three: "{primary.500}",
                        four: "{primary.500}",
                    }
                }
            }
        },
        fileupload: {
            header: {
                padding: 0
            },
            content: {
                padding: '1rem'
            }
        },
        dialog: {
            footer: {
                padding: "var(--p-overlay-modal-padding)"
            }
        },
        datatable: {
            colorScheme: {
                dark: {
                    header: {
                        cell: {
                            background: "{surface.900}",
                            hover: {
                                background: "{surface.900}"
                            }
                        }
                    },
                    row: {
                        background: "{surface.850}",
                        striped: {
                            background: "{surface.750}"
                        }
                    }
                }
            }
        }
    }
});